export const getFileType = (filename) => {
  let extension = filename.split('.').pop()
  return extension
}
